import React, { Component } from 'react'
import { Button, Divider, Row } from 'antd'
import CustomTable from '../../../../elements/Table/CustomTable'

class BankAccountList extends Component {
  render() {
    const { next, prev, setBank, member, lastActionIsNext, banks = [] } = this.props

    // if (!member || banks.length === 0) {
    //   lastActionIsNext ? next() : prev()
    // }

    return (
      <div className="steps-content">
        <Divider orientation="left">Select From Existing Member</Divider>
        <Row>
          <CustomTable
            data={banks}
            hide={{ create: true, refresh: true }}
            isFilterable={true}
            show={{ extraColumns: true }}
            columns={[
              {
                Header: 'Account Name',
                accessor: 'accname',
                width: 350,
              },
              {
                Header: 'Account Number',
                accessor: 'number',
              },
              {
                Header: 'Bank Name',
                accessor: 'bank.name',
                width: 130,
              },
              {
                Header: 'Currency',
                accessor: 'currency',
                width: 100,
              },
              {
                Header: 'Country',
                accessor: 'country',
              },
              {
                Header: 'Intermediary Bank Account Name',
                accessor: 'ibank.name',
                hideable: true,
                hideDefault: true,
              },
              {
                Header: 'Intermediary Bank Branch',
                accessor: 'ibank.branch',
                hideable: true,
                hideDefault: true,
              },
              {
                Header: 'Action',
                width: 90,
                Cell: ({ value, original }) => (
                  <Button
                    type="primary"
                    size="small"
                    onClick={() => {
                      setBank(original)
                      next()
                    }}>
                    Use This
                  </Button>
                ),
              },
            ]}
          />
        </Row>
      </div>
    )
  }
}

export default BankAccountList
